import _ from "lodash";
import store from "store";

/**
 * Page state management mixin.
 * @author James Adams
 */
function HasPageState() {
  this.state.pageState = {};
  this.state.defaultPageState = {};
  this.state.cacheKeys = {};

  /**
   * Add the given object to the pageState list of pages,
   * and setup it's initial default restore point.
   * @param {string} id of the page.
   * @param {object} data state of the page.
   * @public
   */
  this.createPageState = function (id, data) {
    this.state.pageState[id] = _.cloneDeep(data);
    this.state.defaultPageState[id] = _.cloneDeep(data);
  };


  /**
   * Add the given object to the pageState list of pages,
   * and setup it's initial default restore point.
   * @param {string} id of the page.
   * @param {object} data state of the page.
   * @param {array} cacheKeys keys to be cached in storage.
   * @public
   */
  this.createCachedPageState = function (id, data, cacheKeys) {
    this.state.cacheKeys[id] = _.cloneDeep(cacheKeys);
    if(this._checkValidCache(id, cacheKeys)){
      this.state.pageState[id] = this._getCache(id, _.cloneDeep(data));
    }else{
      this._setCache(id, _.cloneDeep(data));
      this.state.pageState[id] = _.cloneDeep(data);
    }
    this.state.defaultPageState[id] = _.cloneDeep(data);
  };


  /**
   *
   */
  this._setCache = function(id, data){
    const cacheKeys = this.state.cacheKeys[id];
    if(cacheKeys){
      const initData = cacheKeys.reduce((newData, key)=>{
        newData[key] = data[key];
        return newData;
      },{});
      store.set(id, initData);
    }
  };


  /**
   *
   */
  this._getCache = function(id, data){
    const cache = store.get(id);
    return Object.assign(data, cache);
  };


  /**
   *
   */
  this._checkValidCache = function(id, cacheKeys){
    const cache = store.get(id);
    if(cache){
      let equal = true;
      cacheKeys.every(key=>{
        if(!cache.hasOwnProperty(key)){
          equal = false;
          return false;
        }
        return true;
      });

      if(equal){
        Object.keys(cache).every(key=>{
          if(!cacheKeys.includes(key)){
            equal = false;
            return false;
          }
          return true;
        });
      }

      return equal;
    }else{
      return false;
    }
  };


  /**
   * Reset the state of a page back to it's initial state.
   * @param {string} id of the page.
   * @param {object} mixin override values to be mixed into the default state.
   * @public
   */
  this.resetPageState = function (id, mixin) {
    let pageState = _.cloneDeep(this.state.pageState);
    this._resetPageState(pageState, id, mixin);
    this.setState({ 'pageState': pageState });
  };


  /**
   *
   */
  this._resetPageState = function(pageState, id, mixin){
    if (pageState[id] && this.state.defaultPageState[id]) {
      pageState[id] = _.cloneDeep(this.state.defaultPageState[id]);
      pageState[id] = Object.assign(pageState[id], mixin);
      this._setCache(id, pageState[id]);
    } else {
      console.error("could not resolve page state for reset " + id);
      throw new Error("could not resolve page state for reset " + id);
    }
  };


  /**
   * Allows reseting multiple pages in one setState call.
   * @param {array} states;
   */
  this.resetMultiplePageState = function(states){
    let pageState = _.cloneDeep(this.state.pageState);
    states.every(state=>{
      const id = state.id;
      const mixin = state.mixin;
      this._resetPageState(pageState, id, mixin);
      return true;
    });
    this.setState({ 'pageState': pageState });
  };


  /**
   *
   */
  this.getPageState = function(id){
    let pageState = _.cloneDeep(this.state.pageState);
    console.log('getPageState',id, pageState[id]);
    return pageState[id];
  }

  /**
   * Update page state for a given component.
   * @param {string} id
   * @param {object} state
   * @param {object} globalstate
   * @todo globalstate is an anti pattern figure out what to do with it.
   * @public
   */
  this.updatePageState = function (id, state, globalstate) {
    if (!id) {
      throw new Error('id is undefined');
    }

    if (globalstate === undefined) {
      this._updatePageState(id, state);
    } else {
      this._updateGlobalState(id, state, globalstate);
    }
  };


  /**
   *
   */
  this._updatePageState = function(id, state){
    let pageState = _.cloneDeep(this.state.pageState);
    if (pageState[id]) {
      pageState[id] = Object.assign(pageState[id], state);
      this._setCache(id, pageState[id]);
    }
    this.setState({ 'pageState': pageState });
  };


  /**
   *
   */
  this._updateGlobalState = function(id, state, globalstate){
    console.warn('updatePageState - globalstate call', 'this usage is going to be deprecated.');
    let cState = _.cloneDeep(this.state);
    for (let key in globalstate) {
      cState[key] = globalstate[key];
    }

    let pageState = cState.pageState;
    if (pageState[id]) {
      pageState[id] = state;
    }
    this.setState(cState);
  };
}



export default HasPageState;
